import React from "react";
import '@fortawesome/free-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faReact, faDocker, faPython } from '@fortawesome/free-brands-svg-icons';
import Chip from '@mui/material/Chip';
import '../assets/styles/Expertise.scss';

const labelsFirst = [
  "React",
  "TypeScript",
  "JavaScript",
  "HTML5",
  "CSS3",
  "SASS",
  "Flask",
  "Python",
  "SQL",
  "PostgreSQL",
  "Postman",
  "MySQL",
  "Django",
  "RESTAPI"
];

const labelsSecond = [
    "Git",
    "GitHub Actions",
    "Docker",
    "AWS",
    "Azure",
    "Linux",
    "Snowflake",
    "Pandas",
    "Selenium",
];

const labelsThird = [
  // LLM & GenAI
  "OpenAI",
  "Groq",
  "LangChain",
  "LlamaIndex",
  "Hugging Face",
  "Qdrant",
  "Streamlit",

  // Deep Learning Frameworks
  "PyTorch",
  "TensorFlow",
  "Keras",
  "Transformers",
  "fastai",
  "ONNX",
  "Ray",

  // NLP-Specific Libraries
  "spaCy",
  "NLTK",
  "Gensim",
  "TextBlob",
  "BERT",
  "RoBERTa",
  "GPT",
  "T5",
  "SentenceTransformers",

  // ML Tools & Experiment Tracking
  "Weights & Biases",
  "MLflow",

  // Data Handling & Preprocessing
  "NumPy",
  "Pandas",

  // Visualization
  "Matplotlib",
  "Seaborn",

  // Development & Notebooks
  "Jupyter Notebook",
  "Google Colab",
  "Docker"
];


function Expertise() {
    return (
    <div className="container" id="expertise">
        <div className="skills-container">
            <h1>Expertise</h1>
            <div className="skills-grid">

            <div className="skill">
                <FontAwesomeIcon icon={faReact} size="3x" />
                <h3>Full Stack Web Development</h3>
                <p>
                Build scalable, modern web applications using technologies like React and Flask. Skilled across the full SDLC with strong frontend and backend capabilities.
                </p>
                <div className="flex-chips">
                <span className="chip-title">Tech stack:</span>
                {labelsFirst.map((label, index) => (
                    <Chip key={index} className='chip' label={label} />
                ))}
                </div>
            </div>

            <div className="skill">
                <FontAwesomeIcon icon={faDocker} size="3x" />
                <h3>DevOps & Automation</h3>
                <p>
                Design and implement CI/CD pipelines, testing automation, and deployment workflows to streamline product delivery and ensure stability at scale.
                </p>
                <div className="flex-chips">
                <span className="chip-title">Tech stack:</span>
                {labelsSecond.map((label, index) => (
                    <Chip key={index} className='chip' label={label} />
                ))}
                </div>
            </div>

            <div className="skill">
                <FontAwesomeIcon icon={faPython} size="3x" />
                <h3>Deep Learning, GenAI & LLMs</h3>
                <p>
                Develop enterprise-grade AI solutions using LLMs and deep learning to automate workflows, enhance decision-making, and drive innovation.
                </p>
                <div className="flex-chips">
                <span className="chip-title">Tech stack:</span>
                {labelsThird.map((label, index) => (
                    <Chip key={index} className='chip' label={label} />
                ))}
                </div>
            </div>

            </div>
        </div>
    </div>

    );
}

export default Expertise;